const ALL_SCHEDULE_ROLES = new Set([
  'ROLE_ADMIN',
  'ROLE_SUPERADMIN',
  'ROLE_DIRECTOR',
  'ROLE_BOD',
  'ROLE_MANAGER',
  'ROLE_OPERATION_MANAGER',
  'ROLE_SCHEDULER',
  'ROLE_TECHNICAL',
  'ROLE_TECHNICAL_EXPERT',
  'ROLE_TECHNICAL_REVIEW',
  'ROLE_TECHNICAL_REVIEWER',
  'ROLE_CERTIFICATE_ISSUANCE',
  'ROLE_CERTIFICATE_DECISION',
  'ROLE_CERTIFICATION_ISSUER',
  'ROLE_CERTIFICATION_REVIEW',
  'ROLE_CERTIFICATE_REVIEWER',
  'ROLE_CERTIFICATION_REVIEWER',
  'ROLE_CERTIFICATION_AUTHORITY',
]);

const normalizeRole = (role) => String(typeof role === 'object' ? role?.name : role || '')
  .trim()
  .toUpperCase();

const collectRoles = (viewer) => [viewer?.role, viewer?.roleName, ...(Array.isArray(viewer?.roles) ? viewer.roles : [])]
  .map(normalizeRole)
  .map((role) => role && (role.startsWith('ROLE_') ? role : `ROLE_${role}`))
  .filter(Boolean);

export const canViewAllScheduledCalendar = (viewer) => {
  const hasAllowedRole = collectRoles(viewer).some((role) => ALL_SCHEDULE_ROLES.has(role));
  const jobTitle = String(viewer?.jobTitle || '').trim().toLowerCase();
  return hasAllowedRole || jobTitle.includes('manager') || jobTitle.includes('head');
};

const isAssignedToViewer = (schedule, viewerId) => {
  if (String(schedule?.employeeId || '') === String(viewerId)) return true;
  return Array.isArray(schedule?.assignees)
    && schedule.assignees.some((assignee) => String(assignee?.userId || assignee?.id || '') === String(viewerId));
};

const matchesScheduleType = (schedule, scheduleType) => {
  if (scheduleType === 'audit') return schedule?.scheduleKind === 'audit';
  if (scheduleType === 'non-audit') return schedule?.scheduleKind === 'general';
  return true;
};

export const filterScheduledCalendar = (schedules, viewer, requestedScope = 'own', scheduleType = 'all') => {
  const list = Array.isArray(schedules) ? schedules : [];
  const viewerId = viewer?.id ?? viewer?.userId;
  const canViewAll = canViewAllScheduledCalendar(viewer);
  const scope = requestedScope === 'all' && canViewAll ? 'all' : 'own';
  const scoped = scope === 'all'
    ? list
    : viewerId == null ? [] : list.filter((schedule) => isAssignedToViewer(schedule, viewerId));

  return scoped.filter((schedule) => matchesScheduleType(schedule, scheduleType));
};

export const filterScheduledCalendarForViewer = (schedules, viewer) => (
  filterScheduledCalendar(schedules, viewer, canViewAllScheduledCalendar(viewer) ? 'all' : 'own')
);
